;
define("product_views_option_text.tpl", function(){});

